const awaitAnimationFrame = () => new Promise(requestAnimationFrame);

function initMobileSearchButton() {
  const mobileSearchButton = document.querySelector<HTMLButtonElement>(
    '[data-popup="mob-search"]',
  );
  const mobileSearchInput =
    document.querySelector<HTMLInputElement>("#mob-search-input");

  if (!mobileSearchButton || !mobileSearchInput) {
    return;
  }

  mobileSearchButton.addEventListener("click", async () => {
    await awaitAnimationFrame();
    await awaitAnimationFrame();
    mobileSearchInput.focus();
  });
}

initMobileSearchButton();
